import React from "react";
import Icon from "../../components/Icon/Icon";
import { H3 } from "../../components/Text/Text";
import { isMobileOrTablet } from "../../utils/helpers/mediaQueries";
import ContactsInfo from "./components/ContactsInfo/ContactsInfo";
import SupportForm from "./components/SupportForm/SupportForm";
import SupportSidebar from "./components/SupportSidebar";

import styles from "./support.module.scss";

const Support = () => {
  const openWhatsapp = () => {
    window.open("https://wa.me/+972772170170");
  };

  return (
    <>
      {!isMobileOrTablet() ? (
        <>
          <div className={styles.sidebarWrapper}>
            <SupportSidebar />
          </div>
          <main className={styles.mainWrapper}>
            <SupportForm />
            <div>
              <H3>Get in touch</H3>
              <ContactsInfo />
            </div>
          </main>
        </>
      ) : (
        <main className={styles.mainWrapper}>
          <H3>Support</H3>
          <ContactsInfo />
          <Icon
            name="whatsappBig"
            className={styles.contactsIcon}
            onClick={openWhatsapp}
          />
        </main>
      )}
    </>
  );
};

export default Support;
